import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Mail, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Empty } from "@/components/PageHeader";
import { api, errMsg, fileUrl, fmtDateTime } from "@/lib/api";
import { RichText } from "@/components/RichEditor";
import { Allegato } from "@/pages/NewsDetail";

const Item = ({ c, open, onToggle, onDelete }) => (
  <div className={`bg-white border rounded-xl overflow-hidden transition-shadow ${open ? "shadow-lg border-emerald-300" : "border-slate-200"}`} data-testid={`comunicazione-${c.id}`}>
    <div className="flex items-start">
    <button onClick={onToggle} className="flex-1 text-left p-5 flex items-start gap-4" data-testid={`comunicazione-toggle-${c.id}`}>
      <Mail className="h-5 w-5 text-emerald-700 mt-1 shrink-0" />
      <div>
        <div className="text-xs font-mono-x uppercase tracking-wider text-muted-foreground">{fmtDateTime(c.created_at)} · {c.destinatari === "tutti" ? "Tutti i tesserati" : `Classe ${c.destinatari}`}</div>
        <div className="font-heading text-xl uppercase text-[#0B192C]">{c.oggetto}</div>
      </div>
    </button>
    {onDelete && (
      <button onClick={() => onDelete(c)} title="Elimina comunicazione" aria-label="Elimina comunicazione" data-testid={`comunicazione-delete-${c.id}`}
        className="m-4 h-9 w-9 shrink-0 grid place-items-center rounded-full text-red-600 hover:bg-red-50 transition-colors"><Trash2 className="h-4 w-4" /></button>
    )}
    </div>
    {open && (
      <div className="px-5 pb-6 sm:pl-14 fade-up">
        {c.foto_id && <img src={fileUrl(c.foto_id)} alt="" className="w-full max-h-96 object-cover rounded-lg mb-4" />}
        <RichText html={c.testo} data-testid={`comunicazione-testo-${c.id}`} />
        {c.allegato_id && <Allegato href={fileUrl(c.allegato_id)} nome={c.allegato_nome} testid={`comunicazione-allegato-${c.id}`} />}
        <p className="text-xs text-muted-foreground mt-4">Inviata da {c.autore}</p>
      </div>
    )}
  </div>
);

export default function Comunicazioni() {
  const [params] = useSearchParams();
  const [items, setItems] = useState(null);
  const [openId, setOpenId] = useState(params.get("id"));
  const { user } = useAuth();
  const load = () => api.get("/comunicazioni").then((r) => setItems(r.data));
  useEffect(() => {
    load();
    setOpenId(params.get("id"));
  }, [params]);
  const remove = async (c) => {
    if (!window.confirm(`Eliminare la comunicazione "${c.oggetto}"? Non sarà più visibile ai tesserati.`)) return;
    try {
      await api.delete(`/admin/comunicazioni/${c.id}`);
      toast.success("Comunicazione eliminata");
      load();
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="max-w-3xl">
      <PageHeader kicker="Dalla segreteria" title="Comunicazioni" />
      {items && items.length === 0 && <Empty data-testid="comunicazioni-empty">Nessuna comunicazione ricevuta.</Empty>}
      <div className="space-y-3" data-testid="comunicazioni-list">
        {items?.map((c) => <Item key={c.id} c={c} open={openId === c.id} onToggle={() => setOpenId(openId === c.id ? null : c.id)} onDelete={user?.role === "admin" ? remove : null} />)}
      </div>
    </div>
  );
}
